import { combineReducers } from 'redux'
import config from './config'
import notification from './notification'
import { reducer as formReducer } from 'redux-form'
import auth from './auth'
import users from './users'
import clients from './clients'
import ibs from './ibs'
import companies from './companies'
import currencies from './currencies'
import profiles from './profiles'
import ibTrees from './ibTrees'
import symbols from './symbols'
import platforms from './platforms'
import accounts from './accounts'
import symbolGroups from './symbolGroups'
import transactions from './transactions'
import adjustments from './adjustments'
import ibReports from './ibReports'
import subProfiles from './subProfiles'
import subProfileRules from './subProfileRules'
import adjustmentsReasons from './adjustmentsReasons'
import profileSpecialCases from './profileSpecialCases'
import ibAccountRules from './ibAccountRules'
import referralLinks from './referralLinks'

const rootReducer = combineReducers({
    config,
    notification,
    auth,
    users,
    clients,
    ibs,
    companies,
    currencies,
    platforms,
    profiles,
    ibTrees,
    symbols,
    accounts,
    ibReports,
    transactions,
    adjustments,
    symbolGroups,
    subProfiles,
    subProfileRules,
    adjustmentsReasons,
    profileSpecialCases,
    ibAccountRules,
    referralLinks,
    form: formReducer
});
export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js